import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from '../../common/DialogModal';
import Typography from 'material-ui/Typography';
import Button from '../../Parts/Button';

const styles = () => ({
  text: {
    marginBottom: "40px",
    textAlign: "left",
  },

  textTitle: {
    marginBottom: "40px",
    textAlign: "left",
    fontWeight: 700
  },

  button: {
    background: "#F03A47",
    "&:hover::before": {
      backgroundColor: "#F03A47",
      opacity: 0.6,
    },
  },

  contentContainer: {
    padding: "50px 40px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    width: "450px",
    boxSizing: "border-box",
    background: "#FFFFFF",
  },

  buttonContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-evenly',
    marginTop: '40px',
  }
});

class OrderDisableDialog extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <DialogModal
        open={this.props.isOpen}
        onClose={this.props.toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.contentContainer
        }}
      >
        <Typography variant="subheading" className={classes.textTitle}>

        </Typography>
        <Typography variant="subheading" className={classes.text}>
          同じ注文に会社宛と個人宛の宛先を混在させることはできません。<br />
          大変申し訳ございませんが分割して注文してくださいませ。
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={this.props.toggleDialog}
            text="キャンセル"
            type="ghost"
          ></Button>
        </div>
      </DialogModal>
    );
  }
}

OrderDisableDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
};

export default withStyles(styles)(OrderDisableDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/OrderDisableDialog.jsx